import { Controller } from "@hotwired/stimulus"

// Wraps the layout-wide Bootstrap modal element (#dialogModal). Shows the
// modal automatically when a turbo-frame named "modal" finishes rendering
// inside it, and exposes a `close` method that other controllers (e.g.
// auth-code-form) can call via outlets.
//
// The app-wide "blocked submit → dismiss modal" listener lives in
// application.js — it must fire even on pages where modal_controller
// hasn't been connected for any reason.
//
// Replaces the inline `turbo:frame-render` handler in application.js.
export default class extends Controller {
  open(event) {
    // Skip if the turbo-frame rendered empty content — this happens when the
    // server returns an empty frame (e.g. acting-as write-block response).
    // Re-showing would add a fresh backdrop on top of the one we're trying
    // to dismiss in application.js.
    if (event && event.target && event.target.children.length === 0) return

    // Reset any stale state from a previous brute-force dismiss
    // (display:none, aria-hidden, disposed bootstrap instance) so a fresh
    // show() doesn't get confused by leftover attributes.
    this.element.style.removeProperty('display')
    this.element.removeAttribute('aria-hidden')
    const existing = window.bootstrap.Modal.getInstance(this.element)
    if (existing) existing.dispose()
    window.bootstrap.Modal.getOrCreateInstance(this.element, {
      backdrop: 'static',
      keyboard: false
    }).show()
  }

  close() {
    window.bootstrap.Modal.getInstance(this.element)?.hide()
  }
}
